(() => {
  if (window.NupCardSavingsLoaded) return;
  window.NupCardSavingsLoaded = true;

  const shellSelector = '[data-nup-card-price-shell]';
  const quantitySelector = '.nup-card-quantity .quantity__input';

  const tierAttr = (shell, quantity, fallback) => {
    const raw = shell?.getAttribute?.(`data-tier-${quantity}`);
    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  };

  const tiersFor = (shell) => ({
    q2: tierAttr(shell, 2, 5),
    q3: tierAttr(shell, 3, 7),
    q4: tierAttr(shell, 4, 10)
  });

  const tierFor = (quantity, tiers) => {
    if (quantity >= 4) return tiers.q4;
    if (quantity === 3) return tiers.q3;
    if (quantity === 2) return tiers.q2;
    return 0;
  };

  const nextTierFor = (quantity, tiers) => {
    if (quantity >= 4) return null;
    if (quantity === 3) return tiers.q4;
    if (quantity === 2) return tiers.q3;
    return tiers.q2;
  };

  const formatClp = (pesos) => '$' + Math.round(pesos).toLocaleString('es-CL');
  const effectiveOff = (reference, finalPrice) => reference > 0 && finalPrice < reference ? Math.round((reference - finalPrice) * 100 / reference) : 0;

  const updateCard = (card) => {
    if (!card) return;

    const shell = card.querySelector(shellSelector);
    const input = card.querySelector(quantitySelector);
    if (!shell || !input) return;

    const discountBlock = shell.querySelector('[data-nup-card-price-discount]');
    const prompt = shell.querySelector('[data-nup-card-price-prompt]');
    const oldPrice = shell.querySelector('[data-nup-card-price-old]');
    const newPrice = shell.querySelector('[data-nup-card-price-new]');
    const meta = shell.querySelector('[data-nup-card-price-meta]');

    const rawQuantity = parseInt(input.value || '1', 10);
    const quantity = Math.max(1, Math.min(10, Number.isFinite(rawQuantity) ? rawQuantity : 1));
    if (String(quantity) !== String(input.value)) input.value = String(quantity);

    const tiers = tiersFor(shell);
    const percentage = tierFor(quantity, tiers);
    const nextPercentage = nextTierFor(quantity, tiers);
    const basePriceCents = parseInt(shell.dataset.basePrice || '0', 10);
    const comparePriceCents = parseInt(shell.dataset.comparePrice || '0', 10);
    const hasBaselineSaving = comparePriceCents > basePriceCents;
    const hasProgressiveSaving = percentage > 0;

    if (!discountBlock || !oldPrice || !newPrice || !meta || !basePriceCents) {
      shell.classList.remove('is-discounted');
      if (discountBlock) discountBlock.setAttribute('aria-hidden', 'true');
      if (prompt) prompt.hidden = true;
      if (meta) {
        meta.textContent = '';
        meta.hidden = true;
      }
      return;
    }

    if (!hasProgressiveSaving) {
      shell.classList.remove('is-discounted');
      discountBlock.setAttribute('aria-hidden', 'true');
      meta.textContent = '';
      meta.hidden = true;
      if (prompt) {
        const reference = hasBaselineSaving ? comparePriceCents : basePriceCents;
        const nextFinal = basePriceCents * (1 - nextPercentage / 100);
        prompt.textContent = `AGREGA OTRO IGUAL → LLEGA A +${nextPercentage}% OFF ADICIONAL`;
        prompt.hidden = false;
      }
      return;
    }

    if (prompt) prompt.hidden = true;

    const baseUnitPesos = basePriceCents / 100;
    const savingBaseUnitPesos = hasBaselineSaving ? comparePriceCents / 100 : baseUnitPesos;
    const discountedUnitPesos = baseUnitPesos * (1 - percentage / 100);

    oldPrice.textContent = formatClp(savingBaseUnitPesos);
    newPrice.textContent = formatClp(discountedUnitPesos);
    const reference = hasBaselineSaving ? comparePriceCents : basePriceCents;
    const finalCents = basePriceCents * (1 - percentage / 100);
    const totalOff = effectiveOff(reference, finalCents);
    if (nextPercentage) {
      const nextFinal = basePriceCents * (1 - nextPercentage / 100);
      meta.textContent = `LLEGASTE A ${totalOff}% OFF · AGREGA OTRO IGUAL → LLEGA A +${nextPercentage}% OFF ADICIONAL`;
    } else {
      meta.textContent = `LLEGASTE A ${totalOff}% OFF · MÁXIMO DESCUENTO`;
    }
    meta.hidden = false;

    shell.classList.add('is-discounted');
    discountBlock.setAttribute('aria-hidden', 'false');
  };

  const updateFromTarget = (target) => {
    updateCard(target?.closest('.product-card-wrapper'));
  };

  document.addEventListener('input', (event) => {
    if (event.target.matches(quantitySelector)) updateFromTarget(event.target);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches(quantitySelector)) updateFromTarget(event.target);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.nup-card-quantity .quantity__button');
    if (!button) return;
    requestAnimationFrame(() => updateFromTarget(button));
  });

  const boot = (root = document) => {
    if (root.matches?.(shellSelector)) {
      updateCard(root.closest('.product-card-wrapper'));
    }

    root.querySelectorAll?.(shellSelector).forEach((shell) => {
      updateCard(shell.closest('.product-card-wrapper'));
    });
  };

  const observeCards = () => {
    if (!document.body || !('MutationObserver' in window)) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) boot(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  const start = () => {
    boot();
    observeCards();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
